/**
 * P010 => 'DNB Forbruksfinansiering',
 * P025 => 'SAGA Likviditetsreserve'
 */
enum LoanUnsecuredInfoProductCode {
  P010 = 'P010',
  P025 = 'P010',
}

export default LoanUnsecuredInfoProductCode;
